import { ProposalSlot, ProposalSlotKind, SlotValues } from "../types";

export type { SlotValues };

// Terms & Services data is read-only: it changes on the contract and is picked
// up on Regenerate. Any other data slot can be typed here, filled or not, and the
// value belongs to this proposal only, never to the record.
export const isReadOnly = (slot: ProposalSlot) =>
  slot.kind === ProposalSlotKind.DATA && !!slot.readOnly;

// A read-only slot always shows what the contract holds, never a typed value.
export const slotValue = (slot: ProposalSlot, values: SlotValues) =>
  (isReadOnly(slot) ? undefined : values[slot.id]) ?? slot.value ?? "";

export const isBlank = (slot: ProposalSlot, values: SlotValues) =>
  slotValue(slot, values).trim() === "";

// A blank the rep can fill here; a read-only one waits on the record instead.
export const needsInput = (slot: ProposalSlot, values: SlotValues) =>
  !isReadOnly(slot) && isBlank(slot, values);

// A blank Send refuses, as contractsapi checks it: a field the rep types, unless
// the template lets it go out blank. A CRM value left blank prints as blank.
export const holdsSend = (slot: ProposalSlot, values: SlotValues) =>
  slot.kind !== ProposalSlotKind.DATA &&
  slot.required !== false &&
  isBlank(slot, values);
